/* Inéa V4 — vidéos clients : lecture muette quand la vidéo est visible, son au clic, flèches de défilement. */
(function () {
  function init(root) {
    if (root.__iv4) return;
    root.__iv4 = true;
    var rail = root.querySelector('[data-ugc-rail]');
    if (!rail) return;
    var videos = Array.prototype.slice.call(rail.querySelectorAll('video'));
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function scrollByCard(dir) {
      var card = rail.querySelector('.card');
      var step = card ? card.getBoundingClientRect().width + 14 : rail.clientWidth * 0.8;
      rail.scrollBy({ left: dir * step, behavior: reduce ? 'auto' : 'smooth' });
    }
    var prev = root.querySelector('[data-ugc-prev]'), next = root.querySelector('[data-ugc-next]');
    if (prev) prev.addEventListener('click', function () { scrollByCard(-1); });
    if (next) next.addEventListener('click', function () { scrollByCard(1); });

    videos.forEach(function (v) {
      v.muted = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.loop = true;
      v.removeAttribute('controls');
      var btn = v.parentNode.querySelector('[data-ugc-sound]');
      function setSound(on) {
        v.muted = !on;
        if (btn) { btn.setAttribute('aria-pressed', on ? 'true' : 'false'); btn.setAttribute('aria-label', on ? 'Couper le son' : 'Activer le son'); }
      }
      function toggle() {
        var on = v.muted;
        // Un seul son à la fois
        if (on) videos.forEach(function (o) { if (o !== v) { o.muted = true; var b = o.parentNode.querySelector('[data-ugc-sound]'); if (b) { b.setAttribute('aria-pressed', 'false'); b.setAttribute('aria-label', 'Activer le son'); } } });
        setSound(on);
        if (v.paused) v.play().catch(function () {});
      }
      if (btn) btn.addEventListener('click', function (e) { e.stopPropagation(); toggle(); });
      v.addEventListener('click', toggle);
    });

    if (reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting && en.intersectionRatio > 0.6) { v.play().catch(function () {}); }
        else if (!v.paused) { v.pause(); }
      });
    }, { threshold: [0, 0.6, 1] });
    videos.forEach(function (v) { io.observe(v); });
  }

  function boot() { document.querySelectorAll('[data-iv4-ugc]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-iv4-ugc]'); if (r) init(r); });
})();
